import { Component, Input, OnInit } from "@angular/core";
import { DataService_ViewSection } from "../shared/data.service";

@Component({
	selector: "caass-section-details",
	templateUrl: "./section-details.component.html",
	styleUrls: ["./section-details.component.css"],
})
export class SectionDetailsComponent implements OnInit {
	constructor(private ViewSectionService: DataService_ViewSection) {}

	ngOnInit(): void {
		if (this.SectionID != -1 && this.SemesterID != -1) {
			this.loadSection();
		} else {
			this.lstSection = [];
		}
	}

	ngOnChanges() {
		if (this.SectionID != -1 && this.SemesterID != -1) {
			this.loadSection();
		} else {
			this.lstSection = [];
		}
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////
	@Input() SectionID: any = -1;
	@Input() SemesterID: any = -1;
	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 1;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedSection: any;
	lstSection: any = [];

	//Filter lists

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "Semester", header: "Semester" },
		{ field: "Day", header: "Day" },
		{ field: "PeriodNo", header: "Period" },
		{ field: "InstructorDesc", header: "Instructor" },
		{ field: "RoomNo", header: "Room" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadSection() {
		this.loading = true;

		var result = this.ViewSectionService.LoadSectionDetails(this.SectionID, this.SemesterID);
		result.subscribe(
			(response) => {
				this.lstSection = response;

				//Load Data Filter Lists

				// for(var i = 0; i < this.lstSection.length; i++){
				//   var next = this.lstSection[i];

				//   next.InstructorDesc = next.FirstName + " " + next.LastName;
				// }

				this.loading = false;
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectedSection = val.data;
	}
	onRowUnselect(val) {
		this.SelectedSection = null;
	}
	////////////////////////////////////////////
}
